export default "__VITE_ASSET__KOrkyAsN__"